export default __webpack_public_path__ + "static/media/complementary--trucks-go-left-ahead--g1.abe94d9d.png";